export default {
  home: 'Home',
  developers: 'Developers',
  agencies: 'Agencies',
  properties: 'Properties',
  login: 'Login',
  registration: 'Sign Up'
}